import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calculator__restriction-text" }
const _hoisted_2 = { class: "calculator__highlight" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__separator" }, null, -1)
const _hoisted_4 = { class: "calculator__restriction-upper-block" }
const _hoisted_5 = { class: "calculator__restriction-text" }
const _hoisted_6 = { class: "calculator__highlight" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__separator" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (!_ctx.$store.state.settings.compactMode)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["calculator__restriction-text-block", { inactive: !_ctx.isHigherTiersBlocked }])
      }, [
        _createVNode(_component_IconBase, {
          height: 24,
          width: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconLock)
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_1, [
          _createTextVNode(" Потрать еще "),
          _createElementVNode("b", _hoisted_2, _toDisplayString(_ctx.howManyPointsToUnlock) + " " + _toDisplayString(_ctx.getDeclension()), 1),
          _createTextVNode(", чтобы получить доступ к Tier‑2/3 навыкам ")
        ]),
        _hoisted_3
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["calculator__restriction-text-block", { inactive: !_ctx.isHigherTiersBlocked }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IconBase, {
            height: 20,
            width: 20
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconLock)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(" Потрать еще "),
            _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.howManyPointsToUnlock) + " " + _toDisplayString(_ctx.getDeclension()), 1),
            _createTextVNode(". ")
          ])
        ]),
        _hoisted_7
      ], 2))
}